import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { UPDATE_AD_SETS_STATUS_MUTATION } from './updateAdSetsStatus.mutation';
import {
  UpdateAdSetsStatusMutation,
  UpdateAdSetsStatusMutation_updateAdSetsStatus_adSets,
  UpdateAdSetsStatusMutationVariables
} from './__generated__/UpdateAdSetsStatusMutation';

type MutationProps = {
  onStart?: (variables: UpdateAdSetsStatusMutationVariables) => void;
  onCompleted?: (adSets: UpdateAdSetsStatusMutation_updateAdSetsStatus_adSets[]) => void;
  onError?: (adSets: UpdateAdSetsStatusMutation_updateAdSetsStatus_adSets[], errors: string[]) => void;
};

export const useUpdateAdSetsStatus = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateAdSetFacebookState] = useMutation<UpdateAdSetsStatusMutation, UpdateAdSetsStatusMutationVariables>(
    UPDATE_AD_SETS_STATUS_MUTATION,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.updateAdSetsStatus?.errors?.length) {
          if (onError) onError(data.updateAdSetsStatus.adSets || [], data.updateAdSetsStatus.errors);
        } else {
          if (onCompleted && data.updateAdSetsStatus?.adSets) onCompleted(data.updateAdSetsStatus.adSets);
        }
      },
      onError: (error) => onError && onError([], [error.message])
    }
  );
  return (variables: UpdateAdSetsStatusMutationVariables) => {
    if (onStart) onStart(variables);
    updateAdSetFacebookState({ variables });
  };
};
